// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7c3e3c37","453":"670e15c7","732":"2d934d8e","977":"b761c659"}[chunkId] + ".chunk.js";
};